<template>
  <div>
    <search abc="找大会, 找视频"></search>
    <div class="tab">
      <ul>
        <li v-for="item in tabList" @click="toggleTab(item)" v-bind:class="{ active: curTab == item.tab}">{{item.name}}</li>
        <!--<li @click="toggleTab('active')" v-bind:class="{ active: all}">活动直播</li>
        <li @click="toggleTab('daka')" v-bind:class="{ active: all}">大咖直播</li>-->
        <!--<li @click="Hot" v-bind:class="{ active: hot}">热门</li>
        <li @click="Now" v-bind:class="{ active: now}">最新</li>
        <li @click="Replay" v-bind:class="{ active: replay}">回放</li>-->
      </ul>
    </div>
    <div class="bars">
      <scroll-bar :url="urlcurrent" v-if="urlcurrent !== 'api/live/zsLiveList?'"></scroll-bar>
      <SubScrollBar :url="urlcurrent" v-if="urlcurrent == 'api/live/zsLiveList?'"></SubScrollBar>
    </div>
  </div>
</template>

<script>
  import SubScrollBar from 'src/components/Commons/SubScrollBars'

  export default {
    data() {
      return {
        urlcurrent: 'api/live/getLives?',
        curTab: 'active',
        all: true,
        hot: false,
        now: false,
        replay: false,
        tabList: [
          {tab: 'active', name: '活动直播', url: 'api/live/getLives?'},
          {tab: 'daka', name: '大咖直播', url: 'api/live/zsLiveList?'}
        ]
      }
    },
    components: {
      SubScrollBar
    },
    created() {
      window.localStorage.setItem("axiosUrl", 'live/detail?id=')
    },
    mounted() {
      this.getShareInfo()
    },
    methods: {
      toggleTab(item) {
        this.curTab = item.tab
        this.urlcurrent = item.url
      },
      All: function () {
        this.urlcurrent = 'api/live/getLives?'  // 活动直播
        this.all = true
        this.hot = false
        this.now = false
        this.replay = false
      },
      Hot: function () {
        this.urlcurrent = 'api/live/getLives?sort=hot&'
        this.all = false
        this.hot = true
        this.now = false
        this.replay = false
      },
      Now: function () {
        this.urlcurrent = 'api/live/getLives?sort=new&'
        this.all = false
        this.hot = false
        this.now = true
        this.replay = false
      },
      Replay: function () {
        this.urlcurrent = 'api/live/getLives?sort=replay&'
        this.all = false
        this.hot = false
        this.now = false
        this.replay = true
      }
    }
  }
</script>

<style lang="less" scoped>
  .tab ul {
    margin-left: 0px !important;
    width: 750px;
    padding: 9px 29px 0 29px;
    background-color: #f4f4f4;
    box-sizing: border-box;
    list-style: none;
    display: flex;
    margin-top: 80px;
    position: fixed;
    top: 0;
    z-index: 10;
    li {
      width: 220px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      flex: 1;
	  font-size:28px;
    }
    .active {
      border-bottom: 1px solid #3e92cb; /*no*/
	    color:#3e92cb;
    }
  }

  .bars {
    margin-top: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Live/Live.vue